import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';
import {
	APP_LOGIN_HINT_PARAM,
	APP_LOGIN_PARAM,
	getSignInAuthorizationParams,
	stripLandingLoginParamsFromUrl,
} from '../common/authLogin';

/** True for this page load while `?login=1` is pending or Auth0 redirect has started (survives param strip). */
let landingLoginRedirectPending = false;

function syncLandingLoginRedirectPendingFromUrl() {
	if (typeof window === 'undefined') {
		return;
	}
	if (new URLSearchParams(window.location.search).get(APP_LOGIN_PARAM) === '1') {
		landingLoginRedirectPending = true;
	}
}

syncLandingLoginRedirectPendingFromUrl();

export function getIsLandingLoginRedirectPending(): boolean {
	return landingLoginRedirectPending;
}

/**
 * Handles `?login=1&login_hint=…` from the marketing site: strips params and starts Auth0
 * (passwordless when REACT_APP_AUTH0_LOGIN_CONNECTION is set).
 */
export function useLandingLoginRedirect() {
	const { loginWithRedirect, isLoading } = useAuth0();
	const startedRef = useRef(false);

	useEffect(() => {
		if (isLoading || startedRef.current) {
			return;
		}

		const params = new URLSearchParams(window.location.search);
		if (params.get(APP_LOGIN_PARAM) !== '1') {
			return;
		}

		startedRef.current = true;
		landingLoginRedirectPending = true;
		const email = (params.get(APP_LOGIN_HINT_PARAM) ?? params.get('email') ?? '').trim();
		stripLandingLoginParamsFromUrl();

		const authorizationParams = getSignInAuthorizationParams(email || undefined);
		void loginWithRedirect(
			Object.keys(authorizationParams).length > 0 ? { authorizationParams } : undefined,
		);
	}, [isLoading, loginWithRedirect]);
}
